import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
    return (
        <div className="pt-24 pb-20 bg-dark-900">
            <div className="container px-4 mx-auto">
                <div className="mx-auto max-w-4xl">
                    <h1 className="mb-8 text-4xl font-bold text-white">Terms of Service</h1>

                    <div className="prose prose-invert">
                        <p className="mb-6 text-dark-300">Last updated: 30/04/2025</p>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">1. License Terms</h2>
                            <p className="mb-4 text-dark-300">
                                WinMax Optimizer licenses are time-based and non-transferable. Your license:
                            </p>
                            <ul className="pl-6 mb-6 list-disc text-dark-300">
                                <li>Is valid for the duration purchased</li>
                                <li>Can be used on one device at a time</li>
                                <li>Cannot be shared or resold</li>
                                <li>Includes access to updates during the license period</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">2. User Responsibilities</h2>
                            <p className="mb-4 text-dark-300">
                                Users must:
                            </p>
                            <ul className="pl-6 mb-6 list-disc text-dark-300">
                                <li>Maintain the security of their license key</li>
                                <li>Use the software in compliance with local laws</li>
                                <li>Not attempt to reverse engineer the software</li>
                                <li>Not use the software for illegal purposes</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">3. Refunds</h2>
                            <p className="mb-4 text-dark-300">
                                Please refer to our{' '}
                                <Link to="/refund-policy" className="text-primary-400 hover:text-primary-300">
                                    Refund Policy
                                </Link>
                                {' '}for detailed information about refunds.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">4. Limitation of Liability</h2>
                            <p className="mb-4 text-dark-300">
                                WinMax Optimizer is provided "as is" without warranty of any kind. We are not
                                responsible for any damages arising from the use of our software.
                            </p>
                        </section>

                        <section>
                            <h2 className="mb-4 text-2xl font-semibold text-white">5. Contact</h2>
                            <p className="text-dark-300">
                                For questions about these terms, please contact{' '}
                                <a href="mailto:support@winmaxoptimizer.com" className="text-primary-400 hover:text-primary-300">
                                    support@winmaxoptimizer.com
                                </a>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;